<div class="modal">
  <div class="card card--lg">
    <div class="card-header">
      <div class="card-title">Detalji za isporuku</div>
    </div>
    <div class="card-body scrollable scrollable--md">
      <form [formGroup]="packingForm" novalidate>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Broj paketa</label>
              <input type="text" mask="separator.2" thousandSeparator="." decimalMarker="," name="numberOfPackages" class="form-control" formControlName="numberOfPackages" />
            </div>
            <div class="form-group">
              <label class="form-label">Broj paleta</label>
              <input type="text" mask="separator.2" thousandSeparator="." decimalMarker="," name="numberOfPallets" class="form-control" formControlName="numberOfPallets" />
            </div>
            <div class="form-group">
              <label class="form-label">Broj redova u paleti</label>
              <input type="text" mask="separator.2" thousandSeparator="." decimalMarker="," name="numberOfRowsPerPallet" class="form-control" formControlName="numberOfRowsPerPallet" />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Broj pakovanja u redu</label>
              <input type="text" mask="separator.2" thousandSeparator="." decimalMarker="," name="numberOfPackagesInRow" class="form-control" formControlName="numberOfPackagesInRow" />
            </div>
            <div class="form-group">
              <label class="form-label">Bruto težina</label>
              <input type="text" mask="separator.2" thousandSeparator="." decimalMarker="," name="grossWeight" class="form-control" formControlName="grossWeight" />
            </div>
            <div class="form-group">
              <label class="form-label">Neto težina</label>
              <input type="text" mask="separator.2" thousandSeparator="." decimalMarker="," name="netWeight" class="form-control" formControlName="netWeight" />
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer d-flex justify-content-end">
      <button class="btn btn-secondary me-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success" (click)="emitTrue()" [disabled]="packingForm.invalid">Sačuvaj</button>
    </div>
  </div>
</div> 
